export const getLocalToken = () => localStorage ? localStorage.getItem('token') : null;

export const saveLocalToken = (token: string) => localStorage ? localStorage.setItem('token', token) : null;

export const removeLocalToken = () => localStorage ? localStorage.removeItem('token') : null;
